// extracted by mini-css-extract-plugin
module.exports = {"userThumbnail":"ArchitectUserCard_userThumbnail__3-n5t","name":"ArchitectUserCard_name__3NGAa","stats":"ArchitectUserCard_stats__3hDOd"};